<template lang="pug">
    .settings-button-wrapper
        button.settings-button(:class="buttonClass" @click="click") {{title}}
</template>

<script>
export default {
    name: "settings-form-button",

    props: {
        title: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
        },
    },

    computed: {
        buttonClass() {
            return {
                'settings-button--disabled': this.disabled,
            }
        },
    },

    methods: {
        click() {
            if (!this.disabled) {
                this.$emit('click')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@media (max-width:700px) {
    .settings-button-wrapper {
        display: flex;
        justify-content: center;
    }
}

</style>
